import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  const nav = (page: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) onNavigate(page);
  };
  return <footer className="bg-gray-50 border-t border-gray-200 py-12 mt-auto" data-id="element-233" data-mp="36nd4feb5q41k">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234" data-mp="3ugbpd4c2b8hr">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8" data-id="element-235" data-mp="3991omvfnkca">
          {/* Logo + Description */}
          <div className="col-span-1 md:col-span-2" data-id="element-236" data-mp="3lf582t1l9tng">
            <button onClick={nav('compare')} className="flex items-center gap-2 hover:opacity-80 transition-opacity mb-4" data-id="element-237" data-mp="3lggb2qn7mxdi">
              <div className="bg-[#e8594f] text-white p-1.5 rounded-lg" data-id="element-238" data-mp="29zgkq0kfasm4">
                <GraduationCapIcon className="w-5 h-5" data-id="element-239" data-mp="2a19uhoqc1syc" />
              </div>
              <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-240" data-mp="2ezuvhqdesgnu">
                FindOnlineDegrees
              </span>
            </button>
            <p className="text-sm text-gray-500 leading-relaxed max-w-md" data-id="element-241" data-mp="3gapf5opniuim">
              We help students find the right educational path by comparing top
              accredited online degree programs. Our mission is to make higher
              education more accessible and transparent.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-242" data-mp="817cg38o1ksh">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-243" data-mp="80nskgzggmbt">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-244" data-mp="33e5h7zjgmr5">
              <li data-id="element-245" data-mp="htd4te2ty487">
                <button onClick={nav('colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-246" data-mp="hrs9hm8oyh9a">
                  Colleges
                </button>
              </li>
              <li data-id="element-247" data-mp="qt8grl47m39a">
                <button onClick={nav('partner-colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-248" data-mp="qsqf28ys2wtz">
                  Partner Colleges
                </button>
              </li>
              <li data-id="element-249" data-mp="tvd0bu5d69g7">
                <button onClick={nav('compare')} className="hover:text-[#3b82f6] text-left" data-id="element-250" data-mp="tvw84i1avhgi">
                  Compare Schools
                </button>
              </li>
              <li data-id="element-251" data-mp="13taji38d9g1y">
                <button onClick={nav('request-information')} className="hover:text-[#3b82f6] text-left" data-id="element-252" data-mp="13sr7121hjjvb">
                  Match to Colleges
                </button>
              </li>
              <li data-id="element-253" data-mp="1clunzkbcaeup">
                <button onClick={nav('articles')} className="hover:text-[#3b82f6] text-left" data-id="element-254" data-mp="1cmdu83rmnesw">
                  Articles
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-255" data-mp="1mkbj8thb9fmk">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-256" data-mp="1mkk00wgk1531">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-257" data-mp="1rhk3czm0rtqg">
              <li data-id="element-258" data-mp="3obetvir7au74">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-259" data-mp="3obx1tcn86wuv">
                  Financial Aid Guide
                </a>
              </li>
              <li data-id="element-260" data-mp="3tai2teaaxkkd">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-261" data-mp="3tc2v0x958rf2">
                  Career Outlooks
                </a>
              </li>
              <li data-id="element-262" data-mp="25nvlazp97s93">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-263" data-mp="25nlq8xpcquwj">
                  Student Reviews
                </a>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div data-id="element-264" data-mp="1worwdf3eoimo">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-265" data-mp="1wpa2d3fveb7s">About Us</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-266" data-mp="2te9c6mw3rl23">
              <li data-id="element-267" data-mp="2tbn50od4j7ke">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-268" data-mp="2pcntum0sueki">
                  Contact Us
                </a>
              </li>
              <li data-id="element-269" data-mp="2kc8ig002vh56">
                <button onClick={nav('privacy-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-270" data-mp="2kbqeeh76bymp">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-271" data-mp="18z5xytuuy7fq">
                <button onClick={nav('terms')} className="hover:text-[#3b82f6] text-left" data-id="element-272" data-mp="18zpi8h7zd7wx">
                  Terms & Conditions
                </button>
              </li>
              <li data-id="element-273" data-mp="2rvhjpy1putct">
                <button onClick={nav('cookie-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-274" data-mp="2ruy08cwf3wwo">
                  Cookie Policy
                </button>
              </li>
              <li data-id="element-275" data-mp="2ivuf73dox7fj">
                <button onClick={nav('ca-notice')} className="hover:text-[#3b82f6] text-left" data-id="element-276" data-mp="2iwcgwfj4gduu">
                  CA Notice at Collection
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-277" data-mp="3bhm6flppps9x">
          <p className="text-xs text-gray-400 text-center mb-4" data-id="element-278" data-mp="3fllh3nob9wvd">
            Advertising Disclosure: This website is an independent,
            advertising-supported comparison service. The offers that appear on
            this site are from companies from which we receive compensation.
            This compensation may impact how and where products appear on this
            site (including, for example, the order in which they appear). We do
            not include all available products or offers.
          </p>
          <p className="text-sm text-gray-500 text-center" data-id="element-279" data-mp="1nkec6iquffur">
            &copy; {currentYear} FindOnlineDegrees. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}